import axios from 'axios';

export const sailthruReOptIn = async (params, callback) => {
  const data = {
    brand_id: window.brand,
    email: params.email
  }

  if (params.source) {
    data.source = params.source;
  }

  try {
    await axios.post('/api/v5/sailthru/reoptin', data);
    callback();
  } catch (error) {
    console.error(error);
  }
};

export const sailthruCompletedModal = async (data, eventName) => {
  const { lead, coupon } = data;
  const email = lead.email;
  const lists = detList();
  const vars = detVars(data);
  var anonymousId = window.getAnonymousId();
  const payload = {
    brand: window.web_brand,
    brand_id: window.brand,
    anonymous_id: anonymousId,
    coupon,
    user_agent: window.navigator.userAgent,
    event: eventName,
    email,
    id: email,
    vars,
    lists
  }

  try {
    await axios.post('/api/v5/sailthru/custom_event', payload);
  } catch (error) {
    console.error(error);
  }
};

const detVars = ({ lead, prefix }) => {
  const variables = {
    first_name: lead?.first_name,
    last_name: lead?.last_name,
    campaign_prefix: prefix,
    brand: window.web_brand
  };

  const params = new URLSearchParams(window.location.search);
  const utms = {};
  for (let pair of params.entries()) {
    utms[pair[0]] = pair[1];
  }

  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((param) => {
    if (utms[param]) {
      variables[param.replace(/^utm_/, '')] = utms[param];
    }
  });

  variables.source = variables.source || 'website';
  return variables;
};

const detList = () => {
  var list;
  if (window.production_env == 'true') {
    list = {
      MASTER_LIST: 1,
    };
  } else {
    list = {
      'Development Master List': 1,
    };
  }
  return list;
};
